module.exports = __webpack_public_path__ + "static/media/grip-plus.2e5f2e38.svg";